export default "__VITE_ASSET__1954bd57__"